// extracted by mini-css-extract-plugin
export var container = "_sc-0";
export var dotAnimation = "_sc-2";
export var dotsLoading = "_sc-1";